import Link from 'next/link';
import Logo from './ui/Logo';

const NAV_COLS = [
    {
        heading: 'Empresa',
        links: [
            { label: 'Inicio', to: '/' },
            { label: 'Nosotros', to: '/#nosotros' },
            { label: 'IA & Automatización', to: '/software-ia' },
            { label: 'Proceso', to: '/#proceso' },
            { label: 'Contacto', to: '/contacto' },
        ],
    },
    {
        heading: 'Servicios',
        links: [
            { label: 'Sistema de Reservas', to: '/soluciones/reservas' },
            { label: 'Pasarelas de Pago', to: '/soluciones/pagos' },
            { label: 'CRM a Medida', to: '/soluciones/crm' },
            { label: 'Automatizaciones', to: '/soluciones/automatizaciones' },
            { label: 'Web de Captación', to: '/soluciones/web' },
            { label: 'Dashboard & Analytics', to: '/soluciones/dashboard' },
        ],
    },
    {
        heading: 'Por Sector',
        links: [
            { label: 'Hostelería', to: '/sectores/hosteleria' },
            { label: 'Gestoría', to: '/sectores/gestoria' },
            { label: 'Construcción', to: '/sectores/construccion' },
            { label: 'Clínicas', to: '/sectores/clinicas' },
            { label: 'Formación', to: '/sectores/formacion' },
            { label: 'E-commerce', to: '/sectores/ecommerce' },
            { label: 'Peluquerías', to: '/sectores/peluqueria' },
        ],
    },
    {
        heading: 'Legal',
        links: [
            { label: 'Privacidad', to: '/privacidad' },
            { label: 'Términos de uso', to: '/terminos' },
            { label: 'Cookies', to: '/cookies' },
            { label: 'Seguridad', to: '/seguridad' },
            { label: 'Soporte', to: '/soporte' },
            { label: 'Contacto', to: '/contacto' },
        ],
    },
];

export default function SiteFooter() {
    return (
        <footer className="bg-slate-900 border-t border-white/[0.06] relative z-20">

            {/* ── Top: logo + columns ── */}
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 sm:gap-8 lg:grid-cols-5">

                {/* Brand col */}
                <div className="col-span-2 sm:col-span-3 lg:col-span-1 flex flex-col gap-5">
                    <Link href="/" aria-label="Innovathera — Ir a inicio" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                        <Logo height={26} className="text-white/60 hover:text-white/80 transition-colors" />
                    </Link>
                    <p className="text-sm text-white/55 leading-relaxed max-w-[220px]">
                        Asesoría tecnológica + implementación. Diagnosticamos, proponemos y ejecutamos.
                    </p>

                    {/* Datos legales / facturación */}
                    <div className="text-[11px] text-white/40 font-mono leading-relaxed space-y-0.5 max-w-[240px]">
                        <p>Innovathera Technology · Teodor Chavdarov</p>
                        <p>NIF X8562855R</p>
                        <p>Calle Costa Verde Nº 5, 3B</p>
                        <p>28400 Collado Villalba · Madrid</p>
                    </div>

                    {/* Social — icon row */}
                    <div className="flex items-center gap-2 mb-3">
                        <a href="https://www.instagram.com/innovathera.tech" target="_blank" rel="noopener noreferrer" aria-label="Instagram"
                            className="w-8 h-8 rounded-lg flex items-center justify-center text-neutral-500 hover:text-pink-400 hover:bg-white/[0.06] transition-all">
                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                            </svg>
                        </a>
                        <a href="https://www.tiktok.com/@innovathera.tech" target="_blank" rel="noopener noreferrer" aria-label="TikTok"
                            className="w-8 h-8 rounded-lg flex items-center justify-center text-neutral-500 hover:text-white hover:bg-white/[0.06] transition-all">
                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.75a8.18 8.18 0 004.76 1.52V6.84a4.84 4.84 0 01-1-.15z" />
                            </svg>
                        </a>
                        <a href="https://x.com/innovathera" target="_blank" rel="noopener noreferrer" aria-label="Twitter / X"
                            className="w-8 h-8 rounded-lg flex items-center justify-center text-neutral-500 hover:text-white hover:bg-white/[0.06] transition-all">
                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                            </svg>
                        </a>
                    </div>

                    {/* Contact info */}
                    <div className="flex flex-col gap-2">
                        <a href="https://wa.me/34672724676" target="_blank" rel="noopener noreferrer"
                            className="group flex items-center gap-2.5 text-neutral-500 hover:text-green-400 transition-colors">
                            <svg className="w-4 h-4 shrink-0" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                            </svg>
                            <span className="text-xs font-mono tracking-wide">672 724 676</span>
                        </a>
                        <a href="mailto:info@innovatheratech.com"
                            className="group flex items-center gap-2.5 text-neutral-500 hover:text-blue-400 transition-colors">
                            <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            <span className="text-xs font-mono tracking-wide">info@innovatheratech.com</span>
                        </a>
                        <a href="mailto:soporte@innovatheratech.com"
                            className="group flex items-center gap-2.5 text-neutral-500 hover:text-blue-400 transition-colors">
                            <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                            <span className="text-xs font-mono tracking-wide">soporte@innovatheratech.com</span>
                        </a>
                    </div>
                </div>

                {/* Nav columns */}
                {NAV_COLS.map((col) => (
                    <div key={col.heading} className="flex flex-col gap-3">
                        <p className="text-[10px] font-mono tracking-[0.22em] text-white/50 uppercase mb-1">
                            {col.heading}
                        </p>
                        {col.links.map((link) => (
                            <Link
                                key={link.label}
                                href={link.to}
                                className="text-sm text-white/60 hover:text-white/70 transition-colors duration-200"
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>
                ))}
            </div>

            {/* ── Compliance bar ── */}
            <div className="border-t border-white/[0.05] max-w-7xl mx-auto px-6 lg:px-8 pt-5">
                <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[10px] font-mono text-neutral-600 tracking-wider uppercase">
                    <span>Verifactu vía Holded</span>
                    <span className="text-neutral-700">·</span>
                    <span>LOPD / RGPD</span>
                    <span className="text-neutral-700">·</span>
                    <span>Procesos alineados ISO 9001 e ISO 27001</span>
                </div>
            </div>

            {/* ── Bottom bar ── */}
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="text-xs font-mono text-neutral-600 tracking-widest uppercase">
                    © {new Date().getFullYear()} Innovathera Technology — Todos los derechos reservados.
                </p>
                <p className="text-xs text-neutral-700 font-mono">Madrid, España</p>
            </div>
        </footer>
    );
}
